import { cloneElement, useLayoutEffect, useRef, useState } from 'react';

// Hidden tabs have no dimensions. Mount a chart only after its frame is measurable.
export const ChartViewport = ({ children, testId }) => {
  const frame = useRef(null);
  const [size, setSize] = useState({ width: 0, height: 0 });
  useLayoutEffect(() => {
    const measure = () => {
      const bounds = frame.current?.getBoundingClientRect();
      if (!bounds) return;
      const width = Math.floor(bounds.width);
      const height = Math.floor(bounds.height);
      setSize(previous => previous.width === width && previous.height === height ? previous : { width, height });
    };
    measure();
    const observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(measure);
    observer?.observe(frame.current);
    window.addEventListener('resize', measure);
    return () => { observer?.disconnect(); window.removeEventListener('resize', measure); };
  }, []);
  return <div ref={frame} className="w-full h-full min-w-0" data-testid={testId}>
    {size.width > 0 && size.height > 0 ? cloneElement(children, size) : null}
  </div>;
};